<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_responsible.webp`)">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />

        <h1 class="main-title">
          責任あるギャンブル
        </h1>

        <h2 class="subheading fs_6">
          勝winはお客様のギャンブル体験が建設的で、合法で且つ楽しめるものであることを保証するために務めております。
        </h2>

        <h2 class="subheading fs_6">
          我々はギャンブルが一つの娯楽のひとつであることを熟知しておりますが、各メンバー様の健康と責任あるギャンブルにおいても同時に重視ししております。
        </h2>

        <hr class="hr_line my_5r">

        <h1 class="main-title">
          1.制限時間を設定する
        </h1>

        <h2 class="subheading fs_6 mb_5r">
          制限時間を設定し、それを守るようにしてください。<br>

          ギャンブルだけがあなたの趣味ではありません。<br>

          ギャンブルと他の趣味のバランスを見つけることを心がけてください。
        </h2>

        <h1 class="main-title">
          2.賢く遊ぶ
        </h1>

        <h2 class="subheading fs_6 mb_5r">
          極度に緊張しているとき、落ち込んでいるとき、または極度のストレスにさらされているときは、ギャンブルをしないことを選択するのが賢明です。
        </h2>

        <h1 class="main-title">
          3.休息
        </h1>

        <h2 class="subheading fs_6 mb_5r">
          疲労が溜まっている時または集中力が低下している際は、休息を取るようにしてください。
        </h2>

        <h1 class="main-title">
          4.アカウントは1つのみ作成
        </h1>

        <h2 class="subheading fs_6 mb_5r">
          ギャンブルにどれだけの時間とお金を費やしているかを把握するために、複数のアカウントを作成することを禁止いたします。
        </h2>

        <h1 class="main-title">
          5.未成年への保護
        </h1>

        <h2 class="subheading fs_6 mb_5r">
          当サイトでは未成年がギャンブルをすることを、厳格に禁じております<br>

          また、当サイトでは年齢確認手続きを通じて、メンバー様が合法的にギャンブルができる年齢に達していることを保証いたします。
        </h2>
      </div>
      <!-- content End -->
    </div>
    <!-- article-box End -->
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'
export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
    }
  },
  computed: {
  },
  created() {
  },
  methods: {
  }
}
</script>
